module.exports = __webpack_public_path__ + "img/img_futa_roundstitch.30dbf9d4.png";